import {
  LinkType,
  MetaLink,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/meta_bar.types';
import {Link} from '@aboutyou/router';
import {COLORS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useTrackMetaBarOriginClick} from '../hooks/useOriginClickTrackingFunction';
import {MetaBarItemIcon} from './MetaBarItemIcon';

interface MetaBarLinksProps {
  links: MetaLink[];
}

export const MetaBarLinks: React.FC<MetaBarLinksProps> = ({links}) => {
  const trackMetaBarItemClick = useTrackMetaBarOriginClick();

  return (
    <>
      {links.map(({link, type}, index) => (
        <MetaBarItemWithLink
          data-testid={`metaBarItem_${LinkType[type]}`}
          key={`metaBarItem_${index}`}
          to={link.linkTarget.url}
          onClick={trackMetaBarItemClick}
        >
          <MetaBarItemIcon type={type} />
          <span>{link.label}</span>
        </MetaBarItemWithLink>
      ))}
    </>
  );
};

export const MetaBarItemWithLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${COLORS.Grey1};
  padding: 0 10px;

  span {
    margin-left: 4px;
  }

  &:hover {
    background-color: ${COLORS.Grey3} !important;
  }
`;
